<template>
    <b-modal
            v-model="show"
            title="Добавление партнера"
            @hide="close(false)"
    >
        <div>
            <b-container fluid>
                <b-row no-gutters class="mb-2">
                <b-col>
                    <label class="custom-input-label">Наименование партнера</label>
                    <b-form-select
                            placeholder="Пожалуйста выберите партнера из списка"
                            required
                            :options="organizationsList"
                            value-field="id"
                            text-field="orgName"
                            v-model="partnerToGridModel.subordinateOrgId"
                    />
                </b-col>
                </b-row>
            </b-container>
        </div>

        <template v-slot:modal-footer>
            <div class="w-100">
                <v-row no-gutters  justify="space-between">

                    <v-spacer></v-spacer>
                    <v-col cols="auto" class="mr-2">
                        <v-btn
                                color="var(--color-blue)"
                                dark
                                size="sm"
                                @click="onSave"
                        >
                            Сохранить
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn
                                class="cancel-btn"
                                outlined
                                color="var(--color-3)"
                                size="sm"
                                @click="close(false)"
                        >
                            Отмена
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import mapper from 'automapper'

    export default {
        name: "AddNewPartnerToGrid",
        props:["show", "organizationItem"],
        data(){
            return{
                options:[],
                partnerToGridModel:{
                    mainOrgId:this.$props.organizationItem.id,
                    subordinateOrgId: null,
                    subordinateOrgSmallLogo: null,
                    subordinateOrgName: null,
                },
                //Идентити модель для отправки на бэкэнд
                identityModel: {
                    id: null,
                    mainOrgId: null,
                    subordinateOrgId: null,
                    subordinateOrgSmallLogo: null,
                    subordinateOrgName: null,
                },
            }
        },
        created(){
            //Запрашиваем список всех организаций которые можно добавить в партнеры
            this.getAllAvailablePartners();

        },
        computed:{
            //Возвращаем отсортированный по алфавиту список организация для выбора и исключаем добавление самого себя
            organizationsList(){
                let items = this.$store.state.Partners.items;
                const currentOrganizationId = this.$props.organizationItem.id

                return items.filter(org => org.id !== currentOrganizationId).sort((a, b) => {
                    const nameA = a.orgName.toLowerCase(), nameB = b.orgName.toLowerCase()
                    if (nameA < nameB) //сортируем строки по возрастанию
                        return -1
                    if (nameA > nameB)
                        return 1
                    return 0
                })
                },
        },
        methods:{
            getAllAvailablePartners(){
                const vm = this;
                vm.loading = true;
                //Проверяем заполнен ли справочник списком всех организаций
                const itemsStoreLink = this.organizationsList
                if(!itemsStoreLink && itemsStoreLink.length === 0 ){
                    //заполняем данные справочника
                    vm.$store.dispatch("Partners/loadOrganizations").then(() => vm.loading = false).catch((err) => {
                        vm.loading = false
                        this.$bvToast.toast(err.message, {
                            title: `Ошибка загрузки организаций!`,
                            variant: "danger",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    })
                }
            },

            resetItems(){
                for(let key in this.partnerToGridModel){
                    if(key === 'subordinateOrgId')
                        this.partnerToGridModel[key] = null
                    else if(key === 'subordinateOrgSmallLogo')
                        this.partnerToGridModel[key] = null
                    else if(key === 'subordinateOrgName')
                            this.partnerToGridModel[key] = null
                }
            },

            //Проверяем указан ли партнер
            validateModel() {
                let noError = true;
                if (this.partnerToGridModel.subordinateOrgId == null) {
                    this.$bvToast.toast("Необходимо указать партнера", {
                        title: `Необходимо указать партнера!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                    noError = false;
                }
                return noError;
            },
            //Проверяем есть ли уже такой партнер в нашей сетке
            checkForExist(data){
                let noError = true;
                let grid = this.$store.state.Partners.partnerGrid;
                grid.forEach(el => {
                    if (el.subordinateOrgId === data.subordinateOrgId){
                        this.$bvToast.toast("Этот партнер уже добавлен", {
                            title: `Ошибка добавления партнера!`,
                            variant: "warning",
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                        noError = false;
                        return noError;
                    }
                })
                return noError;
            },

            async onSave() {
                const data  = this.partnerToGridModel
                const vm = this;
                if(this.validateModel() === true) {
                    if(this.checkForExist(data) === true){
                        //проверяем есть ли уже такой партнер в нашей сетке
                        try {
                            //иначе добавляем
                            vm.$store.dispatch("Partners/addPartnerToGrid", data)
                                .then(() => {
                                this.$bvToast.toast("Партнер успешно добавлен", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                                .then(() => {
                                //Закрываем модалку
                                this.close(true);
                            })
                                .catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка добавления партнера!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                        }catch(e){
                            console.log(e)
                        }
                    }
                }
            },

            close(isSave){
                this.$emit("close", isSave)
            }
        },
    }
</script>

<style scoped>


</style>